import axisPointer from './grid.tooltip.axisPointer'
import textStyle from './grid.tooltip.textStyle'

export default {
  name: "tooltip",
  nickname: "提示",
  desc: "本坐标系特定的 tooltip 设定。",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc:
        '是否显示提示框组件，包括提示框浮层和 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.axisPointer">axisPointer</a>。',
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    trigger: {
      name: "trigger",
      nickname: "触发类型",
      desc: "触发类型。",
      value: "item",
      defaultValue: "item",
      type: "pureValue",
    },
    axisPointer,
    position: {
      name: "position",
      nickname: "位置",
      desc: "提示框浮层的位置，默认不设置时位置会跟随鼠标的位置。",
    },
    formatter: {
      name: "formatter",
      nickname: "文本格式化",
      desc: "提示框浮层内容格式器，支持字符串模板和回调函数两种形式。",
    },
    backgroundColor: {
      name: "backgroundColor",
      nickname: "背景色",
      desc: "提示框浮层的背景颜色。",
      value: "rgba(50,50,50,0.7)",
      defaultValue: "rgba(50,50,50,0.7)",
      type: "pureValue",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc: "提示框浮层的边框颜色。",
      value: "#333",
      defaultValue: "#333",
      type: "pureValue",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc: "提示框浮层的边框宽。",
      value: 0,
      defaultValue: 0,
    },
    padding: {
      name: "padding",
      nickname: "内边距",
      desc:
        "提示框浮层内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距。",
      value: 5,
      defaultValue: 5,
      type: "pureValue",
    },
    textStyle,
    extraCssText: {
      name: "extraCssText",
      nickname: "额外CSS文本",
      desc: "额外附加到浮层的 css 样式。如下为浮层添加阴影的示例：",
    },
  },
}
